import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBootstrapComponent } from './simple-icons-bootstrap.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBootstrapComponent ],
    exports:      [ SimpleIconsBootstrapComponent ],
    bootstrap:    []
})
export class SimpleIconsBootstrapModule {}
